const ESIM_DEVICES = {
  apple: {
    name: 'Apple',
    models: [
      { name: 'iPhone 16 Pro Max', patterns: ['iPhone17,2'], compatible: true },
      { name: 'iPhone 16 Pro', patterns: ['iPhone17,1'], compatible: true },
      { name: 'iPhone 16 Plus', patterns: ['iPhone17,4'], compatible: true },
      { name: 'iPhone 16', patterns: ['iPhone17,3'], compatible: true },
      { name: 'iPhone 15 Pro Max', patterns: ['iPhone16,2'], compatible: true },
      { name: 'iPhone 15 Pro', patterns: ['iPhone16,1'], compatible: true },
      { name: 'iPhone 15 Plus', patterns: ['iPhone16,4'], compatible: true },
      { name: 'iPhone 15', patterns: ['iPhone16,3'], compatible: true },
      { name: 'iPhone 14 Pro Max', patterns: ['iPhone15,3'], compatible: true },
      { name: 'iPhone 14 Pro', patterns: ['iPhone15,2'], compatible: true },
      { name: 'iPhone 14 Plus', patterns: ['iPhone15,5'], compatible: true },
      { name: 'iPhone 14', patterns: ['iPhone15,4'], compatible: true },
      { name: 'iPhone 13 Pro Max', patterns: ['iPhone14,3'], compatible: true },
      { name: 'iPhone 13 Pro', patterns: ['iPhone14,2'], compatible: true },
      { name: 'iPhone 13', patterns: ['iPhone14,5'], compatible: true },
      { name: 'iPhone 13 mini', patterns: ['iPhone14,4'], compatible: true },
      { name: 'iPhone 12 Pro Max', patterns: ['iPhone13,4'], compatible: true },
      { name: 'iPhone 12 Pro', patterns: ['iPhone13,3'], compatible: true },
      { name: 'iPhone 12', patterns: ['iPhone13,2'], compatible: true },
      { name: 'iPhone 12 mini', patterns: ['iPhone13,1'], compatible: true },
      { name: 'iPhone 11 Pro Max', patterns: ['iPhone12,5'], compatible: true },
      { name: 'iPhone 11 Pro', patterns: ['iPhone12,3'], compatible: true },
      { name: 'iPhone 11', patterns: ['iPhone12,1'], compatible: true },
      { name: 'iPhone XS Max', patterns: ['iPhone11,6', 'iPhone11,4'], compatible: true },
      { name: 'iPhone XS', patterns: ['iPhone11,2'], compatible: true },
      { name: 'iPhone XR', patterns: ['iPhone11,8'], compatible: true },
      { name: 'iPhone SE (3rd gen)', patterns: ['iPhone14,6'], compatible: true },
      { name: 'iPhone SE (2nd gen)', patterns: ['iPhone12,8'], compatible: true },
      { name: 'iPad Pro 12.9" (6th gen)', patterns: ['iPad14,5', 'iPad14,6'], compatible: true },
      { name: 'iPad Pro 11" (4th gen)', patterns: ['iPad14,3', 'iPad14,4'], compatible: true },
      { name: 'iPad Pro 12.9" (5th gen)', patterns: ['iPad13,8', 'iPad13,9', 'iPad13,10', 'iPad13,11'], compatible: true },
      { name: 'iPad Pro 11" (3rd gen)', patterns: ['iPad13,4', 'iPad13,5', 'iPad13,6', 'iPad13,7'], compatible: true },
      { name: 'iPad Air (5th gen)', patterns: ['iPad13,16', 'iPad13,17'], compatible: true },
      { name: 'iPad Air (4th gen)', patterns: ['iPad13,1', 'iPad13,2'], compatible: true },
      { name: 'iPad (10th gen)', patterns: ['iPad13,18', 'iPad13,19'], compatible: true },
      { name: 'iPad mini (6th gen)', patterns: ['iPad14,1', 'iPad14,2'], compatible: true },
      { name: 'iPhone X', patterns: ['iPhone10,3', 'iPhone10,6'], compatible: false },
      { name: 'iPhone 8', patterns: ['iPhone10,1', 'iPhone10,4'], compatible: false },
      { name: 'iPhone 7', patterns: ['iPhone9,1', 'iPhone9,3'], compatible: false }
    ]
  },
  samsung: {
    name: 'Samsung',
    models: [
      { name: 'Galaxy S24 Ultra', patterns: ['SM-S928'], compatible: true },
      { name: 'Galaxy S24+', patterns: ['SM-S926'], compatible: true },
      { name: 'Galaxy S24', patterns: ['SM-S921'], compatible: true },
      { name: 'Galaxy S23 Ultra', patterns: ['SM-S918'], compatible: true },
      { name: 'Galaxy S23+', patterns: ['SM-S916'], compatible: true },
      { name: 'Galaxy S23', patterns: ['SM-S911'], compatible: true },
      { name: 'Galaxy S22 Ultra', patterns: ['SM-S908'], compatible: true },
      { name: 'Galaxy S22+', patterns: ['SM-S906'], compatible: true },
      { name: 'Galaxy S22', patterns: ['SM-S901'], compatible: true },
      { name: 'Galaxy S21 Ultra', patterns: ['SM-G998'], compatible: true },
      { name: 'Galaxy S21+', patterns: ['SM-G996'], compatible: true },
      { name: 'Galaxy S21', patterns: ['SM-G991'], compatible: true },
      { name: 'Galaxy S20 Ultra', patterns: ['SM-G988'], compatible: true },
      { name: 'Galaxy S20+', patterns: ['SM-G986'], compatible: true },
      { name: 'Galaxy S20', patterns: ['SM-G980', 'SM-G981'], compatible: true },
      { name: 'Galaxy Z Fold 5', patterns: ['SM-F946'], compatible: true },
      { name: 'Galaxy Z Fold 4', patterns: ['SM-F936'], compatible: true },
      { name: 'Galaxy Z Fold 3', patterns: ['SM-F926'], compatible: true },
      { name: 'Galaxy Z Fold 2', patterns: ['SM-F916'], compatible: true },
      { name: 'Galaxy Z Flip 5', patterns: ['SM-F731'], compatible: true },
      { name: 'Galaxy Z Flip 4', patterns: ['SM-F721'], compatible: true },
      { name: 'Galaxy Z Flip 3', patterns: ['SM-F711'], compatible: true },
      { name: 'Galaxy Z Flip', patterns: ['SM-F700'], compatible: true },
      { name: 'Galaxy Note 20 Ultra', patterns: ['SM-N986'], compatible: true },
      { name: 'Galaxy Note 20', patterns: ['SM-N980', 'SM-N981'], compatible: true },
      { name: 'Galaxy A55', patterns: ['SM-A556'], compatible: true },
      { name: 'Galaxy A54', patterns: ['SM-A546'], compatible: true },
      { name: 'Galaxy A35', patterns: ['SM-A356'], compatible: true }
    ]
  },
  google: {
    name: 'Google Pixel',
    models: [
      { name: 'Pixel 9 Pro XL', patterns: ['Pixel 9 Pro XL'], compatible: true },
      { name: 'Pixel 9 Pro', patterns: ['Pixel 9 Pro'], compatible: true },
      { name: 'Pixel 9', patterns: ['Pixel 9'], compatible: true },
      { name: 'Pixel 8 Pro', patterns: ['Pixel 8 Pro'], compatible: true },
      { name: 'Pixel 8', patterns: ['Pixel 8'], compatible: true },
      { name: 'Pixel 8a', patterns: ['Pixel 8a'], compatible: true },
      { name: 'Pixel 7 Pro', patterns: ['Pixel 7 Pro'], compatible: true },
      { name: 'Pixel 7', patterns: ['Pixel 7'], compatible: true },
      { name: 'Pixel 7a', patterns: ['Pixel 7a'], compatible: true },
      { name: 'Pixel 6 Pro', patterns: ['Pixel 6 Pro'], compatible: true },
      { name: 'Pixel 6', patterns: ['Pixel 6'], compatible: true },
      { name: 'Pixel 6a', patterns: ['Pixel 6a'], compatible: true },
      { name: 'Pixel 5', patterns: ['Pixel 5'], compatible: true },
      { name: 'Pixel 5a', patterns: ['Pixel 5a'], compatible: true },
      { name: 'Pixel 4 XL', patterns: ['Pixel 4 XL'], compatible: true },
      { name: 'Pixel 4', patterns: ['Pixel 4'], compatible: true },
      { name: 'Pixel 4a', patterns: ['Pixel 4a'], compatible: true },
      { name: 'Pixel 3 XL', patterns: ['Pixel 3 XL'], compatible: true },
      { name: 'Pixel 3', patterns: ['Pixel 3'], compatible: true },
      { name: 'Pixel 3a', patterns: ['Pixel 3a'], compatible: true },
      { name: 'Pixel Fold', patterns: ['Pixel Fold'], compatible: true }
    ]
  },
  motorola: {
    name: 'Motorola',
    models: [
      { name: 'Razr+ (2024)', patterns: ['motorola razr 50 ultra', 'XT2451'], compatible: true },
      { name: 'Razr (2024)', patterns: ['motorola razr 50', 'XT2443'], compatible: true },
      { name: 'Razr+ (2023)', patterns: ['motorola razr 40 ultra', 'XT2321'], compatible: true },
      { name: 'Razr (2023)', patterns: ['motorola razr 40', 'XT2323'], compatible: true },
      { name: 'Razr (2022)', patterns: ['motorola razr 2022', 'XT2251'], compatible: true },
      { name: 'Razr 5G', patterns: ['motorola razr 5G', 'XT2071'], compatible: true },
      { name: 'Edge+ (2023)', patterns: ['motorola edge 40 pro', 'XT2301'], compatible: true },
      { name: 'Edge (2023)', patterns: ['motorola edge 40', 'XT2303'], compatible: true },
      { name: 'Edge+ (2022)', patterns: ['motorola edge 30 pro', 'XT2201'], compatible: true },
      { name: 'Edge 30', patterns: ['motorola edge 30', 'XT2203'], compatible: true },
      { name: 'Moto G Power 5G (2024)', patterns: ['moto g power 5G - 2024', 'XT2425'], compatible: true }
    ]
  },
  oneplus: {
    name: 'OnePlus',
    models: [
      { name: 'OnePlus 12', patterns: ['CPH2573', 'PJD110'], compatible: true },
      { name: 'OnePlus 12R', patterns: ['CPH2609', 'PJE100'], compatible: true },
      { name: 'OnePlus Open', patterns: ['CPH2551', 'PHN110'], compatible: true },
      { name: 'OnePlus 11', patterns: ['CPH2449', 'PHB110'], compatible: true }
    ]
  },
  xiaomi: {
    name: 'Xiaomi',
    models: [
      { name: 'Xiaomi 14 Ultra', patterns: ['2311DRK48C', '24030PN60G'], compatible: true },
      { name: 'Xiaomi 14', patterns: ['2311DRK48G'], compatible: true },
      { name: 'Xiaomi 13 Ultra', patterns: ['2210132C'], compatible: true },
      { name: 'Xiaomi 13 Pro', patterns: ['2210132G'], compatible: true },
      { name: 'Xiaomi 13', patterns: ['2211133G'], compatible: true },
      { name: 'Xiaomi 12T Pro', patterns: ['22081212UG'], compatible: true },
      { name: 'Redmi Note 13 Pro+ 5G', patterns: ['23090RA98G'], compatible: true }
    ]
  },
  huawei: {
    name: 'Huawei',
    models: [
      { name: 'P40 Pro+', patterns: ['ELS-N39'], compatible: true },
      { name: 'P40 Pro', patterns: ['ELS-NX9', 'ELS-N04'], compatible: true },
      { name: 'P40', patterns: ['ANA-NX9', 'ANA-N29'], compatible: true },
      { name: 'Mate 40 Pro', patterns: ['NOH-NX9'], compatible: true }
    ]
  },
  sony: {
    name: 'Sony',
    models: [
      { name: 'Xperia 1 VI', patterns: ['XQ-EC54', 'XQ-EC72'], compatible: true },
      { name: 'Xperia 1 V', patterns: ['XQ-DQ54', 'XQ-DQ62', 'XQ-DQ72'], compatible: true },
      { name: 'Xperia 1 IV', patterns: ['XQ-CT54', 'XQ-CT62', 'XQ-CT72'], compatible: true },
      { name: 'Xperia 5 V', patterns: ['XQ-DE54', 'XQ-DE72'], compatible: true },
      { name: 'Xperia 5 IV', patterns: ['XQ-CQ54', 'XQ-CQ62', 'XQ-CQ72'], compatible: true },
      { name: 'Xperia 10 V', patterns: ['XQ-DC54', 'XQ-DC72'], compatible: true },
      { name: 'Xperia 10 IV', patterns: ['XQ-CC54', 'XQ-CC72'], compatible: true }
    ]
  },
  oppo: {
    name: 'OPPO',
    models: [
      { name: 'Find X5 Pro', patterns: ['CPH2305', 'PEEM00'], compatible: true },
      { name: 'Find X3 Pro', patterns: ['CPH2173', 'PEEM00'], compatible: true },
      { name: 'Find N2 Flip', patterns: ['CPH2437'], compatible: true },
      { name: 'Reno 6 Pro 5G', patterns: ['CPH2247', 'PENM00'], compatible: true }
    ]
  }
};

class EsimCompatibilityChecker extends HTMLElement {
  constructor() {
    super();
    this.deviceDatabase = ESIM_DEVICES;
    this.detectedDevice = null;
    this.selectedBrand = null;
    this.selectedModel = null;
    this.pendingTimeout = null;
    this.hasCustomDeviceData = false;
  }

  connectedCallback() {
    this.initializeElements();
    this.deviceDatabase = this.loadDeviceData();
    if (this.hasCustomDeviceData) {
      this.populateBrands();
    }
    this.bindEvents();
    this.showManualForm();
  }

  initializeElements() {
    this.loadingEl = this.querySelector('[data-esim-loading]');
    this.resultEl = this.querySelector('[data-esim-result]');
    this.formEl = this.querySelector('[data-esim-form]');
    this.brandSelect = this.querySelector('[data-esim-brand]');
    this.modelSelect = this.querySelector('[data-esim-model]');
    this.checkButton = this.querySelector('[data-esim-check]');
    this.resultContainer = this.querySelector('[data-esim-result-container]');
    this.detectedDeviceEl = this.querySelector('[data-esim-detected-device]');
  }

  loadDeviceData() {
    const dataScript = this.querySelector('[data-esim-devices]');
    if (!dataScript) return ESIM_DEVICES;

    const json = dataScript.textContent.trim();
    if (!json) return ESIM_DEVICES;

    try {
      const parsed = JSON.parse(json);
      const normalized = this.normalizeDeviceData(parsed);
      if (normalized) {
        this.hasCustomDeviceData = true;
        return normalized;
      }
    } catch (error) {
      console.warn('Invalid eSIM device data JSON', error);
    }

    return ESIM_DEVICES;
  }

  normalizeDeviceData(raw) {
    if (!raw) return null;

    if (raw.devices && Array.isArray(raw.devices)) {
      return this.normalizeArray(raw.devices);
    }

    if (Array.isArray(raw)) {
      return this.normalizeArray(raw);
    }

    if (typeof raw === 'object') {
      return this.normalizeObject(raw);
    }

    return null;
  }

  normalizeObject(raw) {
    const normalized = {};

    Object.entries(raw).forEach(([key, brand]) => {
      if (!brand || !brand.models) return;

      const models = Array.isArray(brand.models) ? brand.models : [];
      const normalizedModels = models
        .map((model) => this.normalizeModel(model))
        .filter(Boolean);

      if (normalizedModels.length === 0) return;

      normalized[key] = {
        name: brand.name || key,
        models: normalizedModels
      };
    });

    return Object.keys(normalized).length > 0 ? normalized : null;
  }

  normalizeArray(list) {
    const normalized = {};

    list.forEach((entry) => {
      if (!entry) return;

      const rawBrandKey = entry.brand_key || entry.brandKey || entry.brand || entry.brand_name || entry.brandName;
      const rawBrandName = entry.brand || entry.brand_name || entry.brandName || rawBrandKey;
      const modelName = entry.model || entry.name;

      if (!rawBrandKey || !String(rawBrandKey).trim() || !modelName || !String(modelName).trim()) return;

      const brandKey = this.normalizeBrandKey(rawBrandKey);
      const brandName = String(rawBrandName).trim() || brandKey;

      if (!normalized[brandKey]) {
        normalized[brandKey] = {
          name: brandName,
          models: []
        };
      }

      normalized[brandKey].models.push({
        name: String(modelName).trim(),
        patterns: this.normalizePatterns(entry.patterns || entry.pattern || entry.match || []),
        compatible: this.normalizeCompatibility(entry.compatibility ?? entry.compatible ?? entry.status)
      });
    });

    return Object.keys(normalized).length > 0 ? normalized : null;
  }

  normalizeModel(model) {
    if (!model || !model.name) return null;

    return {
      name: String(model.name).trim(),
      patterns: this.normalizePatterns(model.patterns || model.pattern || []),
      compatible: this.normalizeCompatibility(model.compatible ?? model.compatibility)
    };
  }

  normalizePatterns(patterns) {
    if (Array.isArray(patterns)) {
      return patterns.map((pattern) => String(pattern).trim()).filter(Boolean);
    }

    if (typeof patterns === 'string') {
      return patterns
        .split(/[,\n\r]+/)
        .map((pattern) => pattern.trim())
        .filter(Boolean);
    }

    return [];
  }

  normalizeCompatibility(value) {
    if (value === 'likely') return 'likely';
    if (value === true || value === 'true') return true;
    if (value === false || value === 'false') return false;

    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      if (['compatible', 'supported', 'yes', 'y', 'true'].includes(normalized)) return true;
      if (['incompatible', 'unsupported', 'no', 'n', 'false'].includes(normalized)) return false;
      if (normalized === 'likely') return 'likely';
    }

    return 'likely';
  }

  normalizeBrandKey(value) {
    return String(value)
      .trim()
      .toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  getResultType(compatibility) {
    if (compatibility === 'likely') return 'likely';
    return compatibility ? 'compatible' : 'incompatible';
  }

  bindEvents() {
    if (this.brandSelect) {
      this.brandSelect.addEventListener('change', this.handleBrandChange.bind(this));
    }
    if (this.modelSelect) {
      this.modelSelect.addEventListener('change', this.handleModelChange.bind(this));
    }
    if (this.checkButton) {
      this.checkButton.addEventListener('click', this.handleCheck.bind(this));
    }

    this.addEventListener('click', (event) => {
      const retryButton = event.target.closest('[data-esim-retry]');
      if (retryButton) {
        event.preventDefault();
        this.detectDevice();
        return;
      }

      const tryManualButton = event.target.closest('[data-esim-try-manual]');
      if (tryManualButton) {
        event.preventDefault();
        this.showManualForm();
        return;
      }

      const closeBtn = event.target.closest('[data-esim-close]');
      if (closeBtn) {
        event.preventDefault();
        const modal = this.closest('modal-dialog');
        if (modal) {
          if (typeof modal.hide === 'function') {
            modal.hide();
          } else {
            modal.removeAttribute('open');
          }
        }
      }
    });
  }

  async detectDevice() {
    this.showLoading();
    if (this.pendingTimeout) {
      clearTimeout(this.pendingTimeout);
      this.pendingTimeout = null;
    }

    const isMobile = this.isMobileDevice();

    if (!isMobile) {
      this.pendingTimeout = setTimeout(() => this.showManualForm(), 500);
      return;
    }

    try {
      const deviceInfo = await this.getDeviceInfo();
      const result = this.matchDevice(deviceInfo);

      this.pendingTimeout = setTimeout(() => {
        if (result.found) {
          this.detectedDevice = result;
          const resultType = this.getResultType(result.compatibility);
          this.showResult(resultType, result.deviceName);
        } else {
          this.showResult('unknown');
          this.prefillManualForm(deviceInfo);
        }
      }, 1500);
    } catch (error) {
      console.error('Device detection error:', error);
      this.pendingTimeout = setTimeout(() => this.showManualForm(), 500);
    }
  }

  async getDeviceInfo() {
    let model = '';
    let platform = '';
    let platformVersion = '';

    if (navigator.userAgentData?.getHighEntropyValues) {
      try {
        const hints = await navigator.userAgentData.getHighEntropyValues(['model', 'platform', 'platformVersion']);
        model = hints.model || '';
        platform = hints.platform || '';
        platformVersion = hints.platformVersion || '';
      } catch {
      }
    }

    if (!platform && navigator.userAgentData?.platform) {
      platform = navigator.userAgentData.platform;
    }

    const userAgent = navigator.userAgent || '';
    const modelsFromUserAgent = this.extractModelsFromUserAgent(userAgent);

    return {
      userAgent,
      model,
      modelsFromUserAgent,
      platform: platform || navigator.platform,
      platformVersion
    };
  }

  matchDevice(deviceInfo) {
    const matchTargets = this.buildMatchTargets(deviceInfo);

    for (const [brandKey, brand] of Object.entries(this.deviceDatabase)) {
      for (const device of brand.models) {
        for (const pattern of device.patterns) {
          const regex = new RegExp(pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
          if (matchTargets.some(target => regex.test(target))) {
            return {
              found: true,
              brand: brand.name,
              brandKey: brandKey,
              deviceName: device.name,
              compatibility: device.compatible
            };
          }
        }
      }
    }

    return { found: false };
  }

  buildMatchTargets(deviceInfo) {
    const targets = new Set();

    if (deviceInfo?.model) {
      targets.add(String(deviceInfo.model));
    }

    if (Array.isArray(deviceInfo?.modelsFromUserAgent)) {
      deviceInfo.modelsFromUserAgent.forEach(model => {
        if (model) targets.add(String(model));
      });
    }

    if (deviceInfo?.userAgent) {
      targets.add(String(deviceInfo.userAgent));
    }

    return Array.from(targets);
  }

  handleBrandChange(e) {
    this.selectedBrand = e.target.value;
    this.selectedModel = '';
    this.populateModels(this.selectedBrand);
    this.updateCheckButton();
  }

  populateBrands() {
    if (!this.brandSelect) return;

    const placeholder = this.brandSelect.dataset.placeholder || 'Choose a brand';
    this.brandSelect.innerHTML = `<option value="">${placeholder}</option>`;

    Object.entries(this.deviceDatabase).forEach(([brandKey, brand]) => {
      if (!brand || !brand.name) return;
      const option = document.createElement('option');
      option.value = brandKey;
      option.textContent = brand.name;
      this.brandSelect.appendChild(option);
    });

    this.brandSelect.disabled = false;
  }

  populateModels(brandKey) {
    if (!this.modelSelect) return;

    this.modelSelect.innerHTML = `<option value="">${this.modelSelect.dataset.placeholder || 'Choose a model'}</option>`;

    if (!brandKey || !this.deviceDatabase[brandKey]) {
      this.modelSelect.disabled = true;
      return;
    }

    const brand = this.deviceDatabase[brandKey];
    brand.models.forEach(model => {
      const option = document.createElement('option');
      option.value = model.name;
      option.textContent = model.name;
      option.dataset.compatible = model.compatible;
      this.modelSelect.appendChild(option);
    });

    this.modelSelect.disabled = false;
  }

  handleModelChange(e) {
    this.selectedModel = e.target.value;
    this.updateCheckButton();
  }

  updateCheckButton() {
    if (this.checkButton) {
      this.checkButton.disabled = !this.selectedBrand || !this.selectedModel;
    }
  }

  prefillManualForm(deviceInfo) {
    if (!this.brandSelect) return;

    const guessedBrand = this.guessBrandKey(deviceInfo);
    if (!guessedBrand || !this.deviceDatabase[guessedBrand]) return;

    this.brandSelect.value = guessedBrand;
    this.selectedBrand = guessedBrand;
    this.selectedModel = '';
    this.populateModels(guessedBrand);
    this.updateCheckButton();
  }

  handleCheck(e) {
    e.preventDefault();

    if (!this.selectedBrand || !this.selectedModel) return;

    const brand = this.deviceDatabase[this.selectedBrand];
    const device = brand.models.find(m => m.name === this.selectedModel);

    if (device) {
      const resultType = this.getResultType(device.compatible);
      this.showResult(resultType, device.name);
    }
  }

  showLoading() {
    if (this.loadingEl) this.loadingEl.hidden = false;
    if (this.resultEl) this.resultEl.hidden = true;
    if (this.formEl) this.formEl.hidden = true;
  }

  showResult(type, deviceName = null) {
    if (this.loadingEl) this.loadingEl.hidden = true;
    if (this.resultEl) this.resultEl.hidden = false;

    const templates = {
      compatible: this.querySelector('[data-template-compatible]'),
      likely: this.querySelector('[data-template-likely]'),
      incompatible: this.querySelector('[data-template-incompatible]'),
      unknown: this.querySelector('[data-template-unknown]')
    };

    if (this.resultContainer && templates[type]) {
      this.resultContainer.innerHTML = '';
      const clone = templates[type].content.cloneNode(true);

      if (deviceName) {
        const deviceNameEl = clone.querySelector('[data-device-name]');
        if (deviceNameEl) deviceNameEl.textContent = deviceName;

        const detectedEl = clone.querySelector('[data-detected-device]');
        if (detectedEl) detectedEl.hidden = false;
      }

      this.resultContainer.appendChild(clone);
    }

    if (this.formEl) this.formEl.hidden = type !== 'unknown';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'esim_compatibility_check',
      esim_result: type,
      esim_compatible: type === 'compatible' || type === 'likely',
      esim_device: deviceName || 'unknown'
    });
  }

  showManualForm(e) {
    if (e) e.preventDefault();

    if (this.loadingEl) this.loadingEl.hidden = true;
    if (this.resultEl) this.resultEl.hidden = true;
    if (this.formEl) this.formEl.hidden = false;
  }

  guessBrandKey(deviceInfo) {
    const parts = [
      deviceInfo?.model,
      ...(deviceInfo?.modelsFromUserAgent || []),
      deviceInfo?.platform,
      deviceInfo?.userAgent
    ]
      .filter(Boolean)
      .map(part => String(part).toLowerCase());

    const haystack = parts.join(' ');
    const candidates = [
      { key: 'apple', match: /iphone|ipad|ipod/ },
      { key: 'samsung', match: /samsung|sm-/ },
      { key: 'google', match: /pixel|google/ },
      { key: 'motorola', match: /motorola|moto|xt\d{3,4}/ },
      { key: 'oneplus', match: /oneplus/ },
      { key: 'xiaomi', match: /xiaomi|redmi|mi\s/ },
      { key: 'huawei', match: /huawei|honor/ },
      { key: 'sony', match: /sony|xq-/ },
      { key: 'oppo', match: /oppo|cph\d{3,4}/ }
    ];

    const match = candidates.find(candidate => candidate.match.test(haystack));
    return match ? match.key : null;
  }

  extractModelsFromUserAgent(userAgent) {
    if (!userAgent) return [];
    const models = [];
    const addModel = (value) => {
      if (!value) return;
      const normalized = String(value).trim();
      if (!normalized) return;
      if (!models.includes(normalized)) {
        models.push(normalized);
      }
    };

    const androidMatch = userAgent.match(/Android\s[^;]+;\s*([^;]+?)\s*Build/i);
    if (androidMatch) addModel(androidMatch[1]);

    const altBuildMatch = userAgent.match(/;\s*([^;]+?)\s*Build\//i);
    if (altBuildMatch) addModel(altBuildMatch[1]);

    const samsungMatch = userAgent.match(/\b(SM-[A-Z0-9]+)\b/i);
    if (samsungMatch) addModel(samsungMatch[1]);

    const sonyMatch = userAgent.match(/\b(XQ-[A-Z0-9]+)\b/i);
    if (sonyMatch) addModel(sonyMatch[1]);

    const oppoMatch = userAgent.match(/\b(CPH\d{3,4})\b/i);
    if (oppoMatch) addModel(oppoMatch[1]);

    return models;
  }

  isMobileDevice() {
    const userAgent = navigator.userAgent || '';
    const uaDataMobile = navigator.userAgentData?.mobile;

    if (typeof uaDataMobile === 'boolean') {
      return uaDataMobile;
    }

    const isIpad = /Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1;
    return isIpad || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(userAgent);
  }
}

if (!customElements.get('esim-compatibility-checker')) {
  customElements.define('esim-compatibility-checker', EsimCompatibilityChecker);
}

const initEsimModalHandlers = () => {
  if (window.esimModalHandlersInitialized) return;
  window.esimModalHandlersInitialized = true;

  document.querySelectorAll('[data-esim-modal-opener]').forEach(opener => {
    opener.addEventListener('click', (event) => {
      event.preventDefault();
      const targetSelector = opener.dataset.esimModalTarget || '#EsimCheckerModal';
      const modal = document.querySelector(targetSelector);
      if (!modal) return;

      if (typeof modal.show === 'function') {
        modal.show(opener);
      } else {
        modal.setAttribute('open', '');
      }
    });
  });

  document.querySelectorAll('[data-esim-modal]').forEach(modal => {
    const observer = new MutationObserver(() => {
      if (!modal.hasAttribute('open')) return;

      const checker = modal.querySelector('esim-compatibility-checker');
      if (checker && typeof checker.showManualForm === 'function') {
        checker.showManualForm();
      }
    });

    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEsimModalHandlers);
} else {
  initEsimModalHandlers();
}
